<template>
  <div class="suppliers-page">
    <!-- 顶部导航 -->
    <header class="back-header">
      <div class="back-btn" @click="$router.back()">←</div>
      <h1>{{ $t('admin.Suppliers.line6_text') }}</h1>
      <div class="header-actions">
        <button class="add-btn" @click="openAddModal">{{ $t('admin.Suppliers.line8_text') }}</button>
      </div>
    </header>

    <!-- 内容 -->
    <div class="main-content">
      <!-- 搜索栏 -->
      <div class="search-bar">
        <input 
          type="text" 
          v-model="searchQuery"
          :placeholder="$t('admin.Suppliers.line19_placeholder')"
          class="search-input"
          @input="handleSearch"
        />
      </div>

      <!-- 批发商列表 -->
      <div class="supplier-list">
        <div v-for="wholesaler in filteredSuppliers" :key="wholesaler.id" class="supplier-card">
          <div class="supplier-info">
            <div class="supplier-name">{{ wholesaler.companyName }}</div>
            <div class="supplier-address">📍 {{ wholesaler.address || '无地址' }}</div>
            <div class="supplier-contact">📞 {{ wholesaler.contactPhone || '无联系方式' }}</div>
          </div>
          <div class="supplier-actions">
            <button class="btn-edit" @click="editSupplier(wholesaler)">{{ $t('common.edit') }}</button>
            <button class="btn-delete" @click="deleteSupplier(wholesaler)">{{ $t('common.delete') }}</button>
          </div>
        </div>

        <!-- 空状态 -->
        <div v-if="filteredSuppliers.length === 0" class="empty-state">
          <div class="empty-icon">📦</div>
          <p>{{ $t('admin.Suppliers.line42_text') }}</p>
        </div>
      </div>
    </div>

    <!-- 新增/编辑弹窗 -->
    <div v-if="showAddModal || showEditModal" class="modal-overlay" @click.self="closeModal">
      <div class="modal">
        <div class="modal-header">
          <div class="modal-title">{{ showAddModal ? '新建批发商' : '编辑批发商' }}</div>
          <button class="modal-close" @click="closeModal">×</button>
        </div>
        <div class="modal-body">
          <div class="form-group">
            <label>{{ $t('admin.Suppliers.line56_text') }}</label>
            <input 
              v-model="formData.companyName"
              :placeholder="$t('admin.Suppliers.line59_placeholder')"
              class="form-input"
            />
          </div>
          
          <div class="form-group">
            <label>{{ $t('admin.Suppliers.line65_text') }}</label>
            <input 
              v-model="formData.address"
              :placeholder="$t('admin.Suppliers.line68_placeholder')"
              class="form-input"
            />
          </div>
          
          <div class="form-group">
            <label>{{ $t('admin.Suppliers.line74_text') }}</label>
            <input 
              v-model="formData.contactPerson"
              :placeholder="$t('admin.Suppliers.line77_placeholder')"
              class="form-input"
            />
          </div>
          
          <div class="form-group">
            <label>{{ $t('admin.Suppliers.line83_text') }}</label>
            <input 
              v-model="formData.contactPhone"
              :placeholder="$t('admin.Suppliers.line86_placeholder')"
              class="form-input"
            />
          </div>
          
          <div class="form-group">
            <label>{{ $t('admin.Suppliers.line92_text') }}</label>
            <textarea 
              v-model="formData.remark"
              :placeholder="$t('admin.Suppliers.line95_placeholder')"
              class="form-textarea"
              rows="3"
            ></textarea>
          </div>
        </div>
        <div class="modal-footer">
          <button class="btn-cancel" @click="closeModal">{{ $t('common.cancel') }}</button>
          <button class="btn-confirm" @click="saveSupplier">{{ $t('common.save') }}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/services/api';

export default {
  name: 'AdminSuppliers',
  data() {
    return {
      suppliers: [],
      filteredSuppliers: [],
      searchQuery: '',
      showAddModal: false,
      showEditModal: false,
      formData: {
        id: null,
        companyName: '',
        address: '',
        contactPerson: '',
        contactPhone: '',
        remark: ''
      }
    };
  },
  mounted() {
    this.loadSuppliers();
  },
  methods: {
    async loadSuppliers() {
      try {
        const response = await api.get('/wholesalers', { params: { page: 0, size: 1000 } });
        // 如果是分页响应，提取 content
        this.suppliers = response.content || response || [];
        this.filteredSuppliers = this.suppliers;
      } catch (error) {
        console.error('加载批发商失败:', error);
      }
    },
    
    async handleSearch() {
      if (!this.searchQuery.trim()) {
        this.filteredSuppliers = this.suppliers;
        return;
      }
      try {
        const response = await api.get('/wholesalers', { 
          params: { 
            page: 0, 
            size: 1000,
            companyName: this.searchQuery.trim()
          } 
        });
        this.filteredSuppliers = response.content || response || [];
      } catch (error) {
        console.error('搜索批发商失败:', error);
      }
    },
    
    openAddModal() {
      console.log('openAddModal 被调用');
      console.log('当前 showAddModal:', this.showAddModal);
      this.formData = {
        id: null,
        companyName: '',
        address: '',
        contactPerson: '',
        contactPhone: '',
        remark: ''
      };
      this.showAddModal = true;
      console.log('设置后 showAddModal:', this.showAddModal);
      this.$nextTick(() => {
        console.log('DOM 更新后，模态框应该显示了');
      });
    },
    
    editSupplier(supplier) {
      this.formData = {
        id: supplier.id,
        wholesalerCode: supplier.wholesalerCode || '',
        companyName: supplier.companyName || '',
        address: supplier.address || '',
        contactPerson: supplier.contactPerson || '',
        contactPhone: supplier.contactPhone || '',
        remark: supplier.remark || ''
      };
      this.showEditModal = true;
    },
    
    async saveSupplier() {
      if (!this.formData.companyName) {
        alert('请输入公司名称');
        return;
      }
      
      try {
        console.log('保存批发商:', this.formData);
        if (this.formData.id) {
          // 更新
          console.log('更新批发商 ID:', this.formData.id);
          const payload = {
            wholesalerCode: this.formData.wholesalerCode || 'WS_UPDATE', // 更新时需要批发商编号
            companyName: this.formData.companyName || '',
            address: this.formData.address || null,
            contactPerson: this.formData.contactPerson || null,
            contactPhone: (this.formData.contactPhone && this.formData.contactPhone.length === 11) ? this.formData.contactPhone : null,
            remark: this.formData.remark || null
          };
          await api.put(`/wholesalers/${this.formData.id}`, payload);
          alert('✅ 更新成功');
        } else {
          // 创建批发商
          console.log('创建批发商');
          // 从 localStorage 获取当前登录用户的 ID（作为创建人）
          const userId = localStorage.getItem('userId') || localStorage.getItem('identityId');
          const payload = {
            wholesalerCode: 'WS_' + Date.now(), // 生成唯一批发商编号
            companyName: this.formData.companyName || '',
            address: this.formData.address || null,
            contactPerson: this.formData.contactPerson || null,
            // 联系电话：空字符串或格式不对时传 null（后端验证会跳过 null）
            contactPhone: (this.formData.contactPhone && this.formData.contactPhone.length === 11) ? this.formData.contactPhone : null,
            remark: this.formData.remark || null
          };
          console.log('payload:', payload);
          // 通过 Header 传递创建人 ID
          const headers = {};
          if (userId && userId !== 'null' && userId !== 'undefined') {
            headers['X-Created-By'] = userId;
          }
          await api.post('/wholesalers', payload, { headers });
          alert('✅ 创建成功');
        }
        
        this.closeModal();
        this.loadSuppliers();
      } catch (error) {
        console.error('保存失败:', error);
        alert('操作失败：' + (error.response?.data?.message || error.message));
      }
    },
    
    async deleteSupplier(supplier) {
      if (!confirm(`确定要删除批发商"${supplier.companyName}"吗？`)) {
        return;
      }
      
      try {
        await api.delete(`/wholesalers/${supplier.id}`);
        alert('✅ 删除成功');
        this.loadSuppliers();
      } catch (error) {
        alert('删除失败：' + (error.response?.data?.message || error.message));
      }
    },
    
    closeModal() {
      this.showAddModal = false;
      this.showEditModal = false;
      this.formData = {
        id: null,
        companyName: '',
        address: '',
        contactPerson: '',
        contactPhone: '',
        remark: ''
      };
    }
  }
};
</script>

<style scoped>
.suppliers-page {
  min-height: 100vh;
  background: #f5f5f5;
  padding-bottom: 80px;
}

.back-header {
  background: linear-gradient(135deg, #ffc069 0%, #fa8c16 100%);
  padding: calc(12px + env(safe-area-inset-top, 0px)) 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  box-shadow: 0 2px 8px rgba(250, 140, 22, 0.15);
}

.back-btn {
  position: absolute;
  left: 16px;
  font-size: 20px;
  color: white;
  cursor: pointer;
}

.back-header h1 {
  font-size: 16px;
  font-weight: 600;
  color: white;
  margin: 0;
}

.header-actions {
  position: absolute;
  right: 16px;
}

.add-btn {
  padding: 8px 16px;
  border: none;
  background: linear-gradient(135deg, #fa8c16, #d46b08);
  color: white;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
}

.add-btn:hover {
  opacity: 0.9;
  transform: translateY(-1px);
}

.main-content {
  padding: 16px;
}

.search-bar {
  margin-bottom: 16px;
}

.search-input {
  width: 100%;
  padding: 12px 16px;
  border: 1px solid #ddd;
  border-radius: 8px;
  font-size: 14px;
}

.supplier-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.supplier-card {
  background: white;
  border-radius: 10px;
  padding: 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-shadow: 0 2px 8px rgba(0,0,0,0.05);
}

.supplier-info {
  flex: 1;
}

.supplier-name {
  font-size: 16px;
  font-weight: 600;
  color: #333;
  margin-bottom: 8px;
}

.supplier-address,
.supplier-contact {
  font-size: 13px;
  color: #666;
  margin-bottom: 4px;
}

.supplier-actions {
  display: flex;
  gap: 8px;
}

.btn-edit,
.btn-delete {
  padding: 6px 16px;
  border: none;
  border-radius: 6px;
  font-size: 13px;
  cursor: pointer;
  transition: all 0.2s;
}

.btn-edit {
  background: #f0f0f0;
  color: #666;
}

.btn-edit:hover {
  background: #e6f4ff;
  color: #667eea;
}

.btn-delete {
  background: #fff1f0;
  color: #ff4d4f;
}

.btn-delete:hover {
  background: #ffccc7;
}

.empty-state {
  text-align: center;
  padding: 80px 20px;
  color: #999;
}

.empty-icon {
  font-size: 64px;
  margin-bottom: 16px;
}

/* 弹窗样式 */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 99999;
  display: flex;
  align-items: center;
  justify-content: center;
  visibility: visible !important;
  opacity: 1 !important;
}

.modal {
  background: white !important;
  border-radius: 12px !important;
  width: 85% !important;
  max-width: 400px !important;
  max-height: 80vh !important;
  overflow-y: auto !important;
  box-shadow: 0 10px 40px rgba(0,0,0,0.2) !important;
  color: #333 !important;
  padding: 0 !important;
  min-height: 200px !important;
}

.modal * {
  color: #333 !important;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 20px;
  border-bottom: 1px solid #eee;
}

.modal-title {
  font-size: 16px;
  font-weight: 600;
  color: #333;
}

.modal-close {
  background: none;
  border: none;
  font-size: 24px;
  color: #999;
  cursor: pointer;
  padding: 0;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.modal-body {
  padding: 20px;
}

.form-group {
  margin-bottom: 16px;
}

.form-group label {
  display: block;
  margin-bottom: 8px;
  font-weight: 500;
  color: #333;
  font-size: 14px;
}

.form-input,
.form-textarea {
  width: 100%;
  padding: 10px 12px;
  border: 1px solid #ddd;
  border-radius: 6px;
  font-size: 14px;
  font-family: inherit;
}

.form-input:focus,
.form-textarea:focus {
  outline: none;
  border-color: #667eea;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
}

.modal-footer {
  display: flex;
  gap: 12px;
  padding: 16px 20px;
  border-top: 1px solid #eee;
}

.btn-cancel,
.btn-confirm {
  flex: 1;
  padding: 12px 24px;
  border: none;
  border-radius: 6px;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
}

.btn-cancel {
  background: #f0f0f0;
  color: #666;
}

.btn-cancel:hover {
  background: #e0e0e0;
}

.btn-confirm {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
}

.btn-confirm:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);
}
</style>
